import { render, staticRenderFns } from "./ITDeviceMonitor.vue?vue&type=template&id=b6f4148c&scoped=true&"
import script from "./ITDeviceMonitor.vue?vue&type=script&lang=js&"
export * from "./ITDeviceMonitor.vue?vue&type=script&lang=js&"
import style0 from "./ITDeviceMonitor.vue?vue&type=style&index=0&id=b6f4148c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f4148c",
  null
  
)

export default component.exports